// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function () {
  const columnResizedEvent = new Event('columnResizedEvent');
  let startX,
    startWidth,
    $handle,
    $table,
    pressed = false;

  // eslint-disable-next-line no-undef
  $(document)
    .on({
      mousemove: function (event) {
        if (pressed) {
          const width = startWidth + (event.pageX - startX);
          $handle.css({
            'min-width': width + 'px',
            width: `${width}px`
          });
        }
      },
      mouseup: function () {
        if (pressed) {
          $table.removeClass('resizing');
          pressed = false;
          document.dispatchEvent(columnResizedEvent);
        }
      }
    })
    .on('mousedown', '.table-resizable th', function (event) {
      // eslint-disable-next-line no-undef
      $handle = $(this);
      pressed = true;
      startX = event.pageX;
      startWidth = +$handle.css('width').replace(/px/g, '');

      $table = $handle.closest('.table-resizable').addClass('resizing');
    });
}
